import React, { forwardRef } from 'react';
import classNames from 'classnames';

/**
 * Replacement for Bootstrap 4's custom-file widget.
 * Usage:
 *   <FileInput id="customFile" label={fileUploadText} onChange={...} />
 */
export const FileInput = forwardRef(function FileInput(
  { id, label, className, inputClassName, labelClassName, ...rest },
  ref
) {
  return (
    <div
      className={classNames(
        'relative inline-block h-11 w-full',
        className
      )}
    >
      <input
        ref={ref}
        id={id}
        type="file"
        {...rest}
        className={classNames(
          'absolute inset-0 z-10 m-0 h-full w-full cursor-pointer opacity-0',
          inputClassName
        )}
      />
      <label
        htmlFor={id}
        className={classNames(
          'absolute inset-0 m-0 flex h-full items-center overflow-hidden',
          'rounded border border-gray-500 bg-gray-100 px-5 py-2.5',
          'text-base font-normal leading-normal text-gray-700',
          'after:absolute after:inset-y-0 after:right-0 after:flex after:items-center',
          'after:border-l after:border-gray-500 after:bg-gray-200 after:px-5 after:py-2.5',
          'after:text-gray-700 after:content-["Browse"]',
          labelClassName
        )}
      >
        <span className="truncate pr-[calc(5rem+1px)]">{label}</span>
      </label>
    </div>
  );
});

export default FileInput;
